import { render, staticRenderFns } from "./SelectInq.vue?vue&type=template&id=b8d2e8f6&scoped=true&"
import script from "./SelectInq.vue?vue&type=script&lang=js&"
export * from "./SelectInq.vue?vue&type=script&lang=js&"
import style0 from "./SelectInq.vue?vue&type=style&index=0&id=b8d2e8f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d2e8f6",
  null
  
)

component.options.__file = "SelectInq.vue"
export default component.exports